import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { Button, Input, Alert } from '../../components/ui';

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    if (!form.email || !form.password) return setError('Email and password required');
    const result = await login(form.email, form.password, true);
    if (result.success) {
      if (!result.user) { setError('Login failed. Please try again.'); return; }
      if (result.user.role !== 'superadmin') { setError('Access denied. Super admin only.'); return; }
      navigate('/admin/dashboard');
    } else setError(result.message || 'Login failed. Check your credentials.');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      {/* Background glow */}
      <div style={{ position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)', width: 400, height: 400, background: 'radial-gradient(circle, rgba(46,204,113,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ marginBottom: 16 }}><span style={{ fontSize: 32, fontWeight: 900, color: "#2ECC71", letterSpacing: -1 }}>MARK</span><span style={{ fontSize: 14, fontWeight: 500, color: "#666", marginLeft: 8 }}>Ms Discoveries</span></div>
          <div style={{ display: 'inline-block', background: 'rgba(46,204,113,0.1)', border: '1px solid rgba(46,204,113,0.3)', borderRadius: 20, padding: '4px 16px', fontSize: 11, fontWeight: 700, color: '#2ECC71', letterSpacing: 2 }}>SUPER ADMIN</div>
        </div>

        {/* Card */}
        <div style={{ background: 'var(--surface-1)', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 20, padding: 36, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 6 }}>Admin Login</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 28 }}>Access the EmailMark admin panel</p>

          {error && <Alert type="danger" style={{ marginBottom: 20 }}>{error}</Alert>}

          <Input label="Admin Email" type="email" placeholder="admin@msdiscoveries.com" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
          <Input label="Password" type="password" placeholder="Enter admin password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />

          <Button fullWidth loading={loading} onClick={handleLogin} size="lg" style={{ marginTop: 8 }}>
            🔐 Login to Admin Panel
          </Button>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <a href="/" style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}>← Back to website</a>
          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: 'var(--text-faint)' }}>
          This is a restricted area. Unauthorized access is prohibited.
        </p>
      </div>
    </div>
  );
}
